import { NavigateFunction } from 'react-router-dom';

export const handleBack = (navigate: NavigateFunction) => {
  navigate(-1);
};
